<script>
export default {
  name: "ReservationSiteBadge",
  props: {
    reservationSiteId: {
      type: String,
      default: ''
    },
  },
  methods: {
    getBackgroundColor() {
      return this.$constant.zzReservationSiteIdBgColor[this.reservationSiteId] ?? '#178045'
    },
    getText() {
      return this.$constant.zzReservationSiteText[this.reservationSiteId] ?? '静'
    },
  },
}
</script>

<template>
  <span
    class="badge font-size-12"
    :style="{
      'background-color': this.getBackgroundColor(),
    }"
  >{{ getText() }}</span>
</template>

<style scoped lang="scss">
.badge {
  padding: 0.4em 0.5em;
}
</style>
